
import React, { FC } from 'react';
import { Row, Spacer, Text, Card, Line, } from '@components/1-atoms';
import { Button, ListItem } from '@components/2-molecules';
import { PageProps } from '@lib/constants';

import useTheme from '@lib/theme';

import * as utils from "@lib/utils";
import { View } from 'react-native';

const theme = useTheme();

type Props = PageProps & {
    currency: string;
};

const WidgetSummaryOfEstimates: FC<Props> = ({ navigation, currency, data }) => {

  const today = new Date();
  const [firstMonthDay, thisMonthDay] = utils.getMonthToDate(today);

  const [documentCount, setDocumentCount] = React.useState<number>(0);
  const [documentTotal, setDocumentTotal] = React.useState<number>(0);

  React.useEffect(() => {
    let count = 0;
    let total = 0;

    data?.forEach((doc: any) => {
      const docCreation = new Date(doc?.createdAt);
      if ((firstMonthDay <= docCreation) && (docCreation <= thisMonthDay)) {
        count++;
        total += doc?.grandTotal;
      }
    });

    setDocumentCount(count);
    setDocumentTotal(total);
  }, [data]);


  return (

    <Card
      title={'Estimate(s) summary'}
      subtitle={`Month to date as of ${utils.formatDate(thisMonthDay, "LLL dd")}`}>
      <Spacer h={2} />

      <Row justification="right"><Text xlarge bold >{documentCount}</Text></Row>
      <Row justification="right"><Text small>estimate(s) sent</Text></Row>
      <Spacer h={1} />
      <Row justification="right"><Text currency={currency} xlarge bold >{documentTotal}</Text></Row>
      <Row justification="right"><Text small>total of the estimate(s) sent</Text></Row>

      <Spacer h={2} />
      <Line />

      <View>
        <ListItem inset onPress={() => navigation?.navigate('EstimateCreate')}>
          <Text color={theme.pallete.accentColor}>Create an estimate</Text>
        </ListItem>
      </View>
    </Card>
  );
};

export default WidgetSummaryOfEstimates;
